import React from 'react';
import MainLayout from '../../layouts/MainLayout.tsx';
import { useNavigate } from 'react-router';
import { useAuth } from '../../context/authContext.tsx';
import { baseurly } from '../../utils/apis.ts';
import { X_API_KEY } from '../../utils/apis.ts';
import { Incident } from '../../Interfaces/types.ts';
import ClientBottomNav from '../../components/ClientBottomNav.tsx';
import { digitalOceanImageUrl } from "../../utils/digitalOcean.ts";



interface Props {
    data: Incident;
    onChange: (f: Partial<Incident>) => void;
    onNext: () => void;
  }

  const IncidentReportForm: React.FC<Props> = ({ data, onChange, onNext }) => {

    const navigate = useNavigate();
    const {employeeI} = useAuth();
  return (
    <MainLayout>
      <div className="min-h-screen bg-blue-900 pb-20">
        {/* Page Title */}
        <div className="px-4 sm:px-6 pt-6">
          <h1 className="text-white text-lg font-medium">
            Equipment Incident Form
          </h1>
        </div>

        {/* White card */}
        <div className="mt-4 bg-white rounded-t-3xl pb-10">
          {/* Sub-header with title + image */}
          <div className="bg-white border rounded-3xl p-4 sm:p-8 mx-4 sm:mx-6 flex flex-col sm:flex-row justify-between items-center">
            <h2 className="font-bold text-blue-900 text-lg mb-4 sm:mb-0">
              Equipment Incident/Accident Form
            </h2>
            <img
              src={digitalOceanImageUrl("products/kayoola_coach/images/orders-coach/carousel.png")}
              alt="Equipment"
              className="w-32 h-auto"
            />
          </div>

          {/* Form */}
          <form 
          className="mt-6 mx-4 sm:mx-6 space-y-6"
          onSubmit={e => {
            e.preventDefault();
            onNext();
          }}>
            <div className="bg-blue-50 p-6 rounded-lg space-y-6">
              {/* Equipment selector */}
              <div>
                <label className="block text-sm font-medium text-blue-900 mb-1">
                  Equipment with a fault
                </label>
                <input 
                      className="w-full border border-gray-300 rounded px-3 py-2" 
                      value={data.equipment}
                      onChange={e => onChange({ equipment: e.target.value })}
                      />
                 
                
              </div>

              {/* Basic Incident Information */}
              <h3 className="text-blue-900 font-semibold">Basic Incident Information</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm text-gray-700 mb-1">Equipment ID</label>
                  <input 
                        type="text" 
                        className="w-full border border-gray-300 rounded px-3 py-2"
                        value={data.equipment_id ? data.equipment_id : ""}
                        onChange={e => {onChange({ equipment_id:e.target.value })}} />
                </div>
                <div>
                  <label className="block text-sm text-gray-700 mb-1">Model/Specification</label>
                  
                   <input
                        type="text"
                        className="w-full border border-gray-300 rounded px-3 py-2"
                        value={data.model}
                        onChange={e => onChange({ model: e.target.value })}
                    />
                </div>
                <div>
                  <label className="block text-sm text-gray-700 mb-1">Workshop</label>
                  <select className="w-full border border-gray-300 rounded px-3 py-2"
                            value={data.work_shop}
                            onChange={e => onChange({ work_shop: e.target.value })}>
                    <option value="">Select Workshop</option>
                    <option value="Body Shop">Body Shop</option>
                    <option value="Chassis Line">Chassis Line</option>
                    <option value="Paint Shop">Paint Shop</option>
                    <option value="Trim Line">Trim Line</option>
                    <option value="QIT">QIT</option>
                    {/* ... */}
                  </select>
                </div>
                <div>
                  <label className="block text-sm text-gray-700 mb-1">Machine Function</label>
                  <input type="text" 
                         className="w-full border border-gray-300 rounded px-3 py-2"
                        value={data.machine_function}
                        onChange={e => onChange({ machine_function: e.target.value })} 
                         />
                </div>
              </div>
                
              {/* Date & Time */}
              <div className=''>
                <label className="block text-sm text-gray-700 mb-1">Date and Time of Incident</label>
                <div className="flex flex-wrap gap-2 mb-4">
                  <input type="datetime-local" 
                         className="border border-gray-300 rounded px-3 py-2"
                          value={data.date_and_time}
                          onChange={e => onChange({ date_and_time: e.target.value })}
                          />
                 
                </div>
                <div className=''>
                  <label className="block text-sm text-gray-700 mb-1">Cause of Incident</label>
                  <input type="text" 
                         className="w-full border border-gray-300 rounded px-3 py-2"
                         value={data.cause}
                         onChange={e => onChange({ cause: e.target.value })} />
                </div>
              </div>

              {/* Operator */}
              <div>
                <label className="block text-sm text-gray-700 mb-1">Equipment Operator</label>
                <input 
                      className="w-full border border-gray-300 rounded px-3 py-2"
                      value={data.operator}
                      onChange={e => onChange({ operator: e.target.value })}
                />
                 
              </div>

              {/* Damage description */}
              <div>
                <label className="block text-sm text-gray-700 mb-1">Describe the equipment damage</label>
                <textarea 
                        className="w-full border border-gray-300 rounded px-3 py-2" rows={3} 
                        value={data.description}
                        onChange={e => onChange({ description: e.target.value })}/>
              </div>
            </div>

            {/* Cause of Loss Statement */}
            <div className="bg-blue-50 p-6 rounded-lg space-y-6">
              <h3 className="text-blue-900 font-semibold">Cause of Loss Statement</h3>
              <div>
                <label className="block text-sm text-gray-700 mb-1">Downtime</label>
                <input type="text" 
                        className="w-full border border-gray-300 rounded px-3 py-2"
                        value={data.down_time}
                        onChange={e => onChange({ down_time: e.target.value })} />
              </div>
              <div className="flex gap-4 items-center">
                <div className="flex-1">
                  <label className="block text-sm text-gray-700 mb-1">Repair Fee</label>
                  <div className="flex">
                    <select className="border border-gray-300 rounded-l px-3 py-2 bg-white">
                      <option>USD</option>
                      <option>EUR</option>
                      <option>UGX</option>
                    </select>
                    <input
                      type="number"
                      placeholder="200.00"
                      className="flex-1 border-t border-b border-gray-300 px-3 py-2 rounded-r"
                      value={data.repair_fee}
                      onChange={e => onChange({ repair_fee: e.target.value })}
                    />
                  </div>
                </div>
                <div className="flex-1">
                  <label className="block text-sm text-gray-700 mb-1">Production Loss</label>
                  <input 
                        type="text" 
                        className="w-full border border-gray-300 rounded px-3 py-2"
                        value={data.production_loss}
                        onChange={e => onChange({production_loss: e.target.value})} />
                        
                </div>
              </div>
              <div>
                <label className="block text-sm text-gray-700 mb-1">Remarks</label>
                <textarea className="w-full border border-gray-300 rounded px-3 py-2" rows={2}
                            value={data.remarks} 
                            onChange={e => onChange({remarks: e.target.value})}/>
              </div>
            </div>

            {/* Next button */}
            <div className="text-center">
              <button
                type="submit"
                className="inline-block bg-blue-900 text-white px-6 py-2 rounded-full hover:bg-blue-800"
               
              >
                Next
              </button>
            </div>
          </form>
        </div>
        <ClientBottomNav showBack={true} />
      </div>
    </MainLayout>
  );
};

export default IncidentReportForm;
